// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25322
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 
import { eventTrackingUtils } from '@/utils/eventTrackingUtils'
interface IPVTrackParamsRecord {
  /** 支付结果页 */
  payment_completed: undefined
}

const sendPv = {
  /** PV-支付结果页 */
  payment_completed: () => {
    eventTrackingUtils.submitPV({ page_id: 'payment_completed' });
  },
}

interface IExpoTrackParamsRecord {}

interface IKeyActionTrackParamsRecord {
  /** 支付信息楼层曝光 */
  payment_completed_pay_info_floor_expo: {
    /** 支付方式  */
    payWay: string,
    /** 支付结果  */
    payResult: string,
    /** 订单id  */
    orderId: string,
    /** 渠道名称  */
    channelName: string
  }
  /** 查看订单按钮曝光 */
  payment_completed_order_details_expo: {
    /** 订单id  */
    orderId: string
  }
  /** 继续购物按钮曝光 */
  payment_completed_continue_shopping_expo: {
    /** 订单id  */
    orderId: string
  }
}

const sendKeyActionTrack = {
  /** 关键事件上报-支付信息楼层曝光 */
  payment_completed_pay_info_floor_expo: (json_param: IKeyActionTrackParamsRecord['payment_completed_pay_info_floor_expo']) => {
    eventTrackingUtils.submitExp({ event_id: 'payment_completed_pay_info_floor_expo', json_param });
  },
  /** 关键事件上报-查看订单按钮曝光 */
  payment_completed_order_details_expo: (json_param: IKeyActionTrackParamsRecord['payment_completed_order_details_expo']) => {
    eventTrackingUtils.submitExp({ event_id: 'payment_completed_order_details_expo', json_param });
  },
  /** 关键事件上报-继续购物按钮曝光 */
  payment_completed_continue_shopping_expo: (json_param: IKeyActionTrackParamsRecord['payment_completed_continue_shopping_expo']) => {
    eventTrackingUtils.submitExp({ event_id: 'payment_completed_continue_shopping_expo', json_param });
  },
}

interface IClickTrackParamsRecord {
  /** 查看订单按钮点击 */
  payment_completed_order_details: {
    /** 订单id  */
    orderId: string
  }
  /** 继续购物按钮点击 */
  payment_completed_continue_shopping: {
    /** 订单id  */
    orderId: string
  }
}

const sendClickTrack = {
  /** 点击事件上报-查看订单按钮点击 */
  payment_completed_order_details: (json_param: IClickTrackParamsRecord['payment_completed_order_details']) => {
    eventTrackingUtils.submitCL({ event_id: 'payment_completed_order_details', json_param });
  },
  /** 点击事件上报-继续购物按钮点击 */
  payment_completed_continue_shopping: (json_param: IClickTrackParamsRecord['payment_completed_continue_shopping']) => {
    eventTrackingUtils.submitCL({ event_id: 'payment_completed_continue_shopping', json_param });
  },
}

export {
  sendClickTrack,
  sendKeyActionTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}